import { ISearchWidget } from 'features/search-widget';

const abritelSearchWidgetConfig: Record<string, ISearchWidget> = {
  abritel: {
    branding: {
      logo: {
        url: 'https://www.abritel.fr/_dms/header/logo.svg?siteid=9003013&locale=fr_FR&3ec60977',
        description: 'Abritel.fr',
      },
    },
    lobs: [
      {
        id: 'stays',
        type: 'HOTELS',
      },
    ],
    search: {
      hostname: 'www.abritel.fr',
      searchParams: {
        siteid: '9003013',
        langid: '1036',
      },
      stays: {
        pathname: '/search',
      },
    },
  },
};

export { abritelSearchWidgetConfig };
